import React, { FC, useMemo } from "react";
import classNames, { Argument } from "classnames/dedupe";

import ProgressBar, { IProgressBarProps } from "../ProgressBar/ProgressBar";
import { IProductCardData, ProductCard } from "../../ProductCard";
import { Carousel } from "../../ActionsSelectors/Carousel";

export type TComparisonData = {
  id: string;
  productCardData: IProductCardData;
  productFeatures?: IProgressBarProps[];
};

export interface IComparisonToolProps {
  /**
   * Data for compared products
   */
  comparisonData: TComparisonData[];
  /**
   * The custom set of css classes used to style component
   */
  classes?: {
    /**
     * applied to outer 'div' element
     */
    root?: Argument;
  };
}

const ComparisonTool: FC<IComparisonToolProps> = ({
  classes,
  comparisonData,
}) => {
  const carouselClass = useMemo(() => {
    switch (comparisonData.length) {
      case 1:
        return "comparison-tool--single";
      case 2:
        return "comparison-tool--twin";
      case 3:
      case 4:
      default:
        return null;
    }
  }, [comparisonData.length]);

  const rootClasses = classNames(
    "comparison-tool uds-carousel",
    classes?.root,
    carouselClass,
  );

  return (
    <Carousel variant="comparison-carousel" classes={{ root: rootClasses }}>
      {comparisonData.map((product, index) => (
        <ProductCard
          key={product.id}
          classes={{
            root: classNames("d-flex", {
              "me-6": index !== comparisonData.length - 1,
            }),
          }}
          isFavoriteAvailable={false}
          productCardData={product.productCardData}
        >
          <div className="product-indicators">
            {product.productFeatures.map((item) => (
              <ProgressBar
                key={`${product.id}-${item.title}`}
                classes={{ root: "mb-6" }}
                title={item.title}
                values={{ currentValue: item.values.currentValue }}
              />
            ))}
          </div>
        </ProductCard>
      ))}
    </Carousel>
  );
};

export default ComparisonTool;
